import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { CultureSection } from './components/CultureSection';
import { ContactSection } from './components/ContactSection';
import { MarqueeStrip } from './components/MarqueeStrip';
import { BackgroundFX } from './components/BackgroundFX';
export function App() {
  return <div className="min-h-screen bg-tux-dark text-white relative overflow-hidden" data-id="element-0">
      <BackgroundFX data-id="element-1" />
      <div className="relative z-10" data-id="element-2">
        <Navbar data-id="element-3" />

        <main data-id="element-4">
          <HeroSection data-id="element-5" />
          <MarqueeStrip data-id="element-6" />
          <ServicesSection data-id="element-7" />
          <CultureSection data-id="element-8" />
        </main>
        <ContactSection data-id="element-9" />
      </div>
    </div>;
}